import { createListFilters } from '../../../../../components'

export type EmpresasClienteFilters = {
  /** Nome do empregador ASO (busca parcial). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<EmpresasClienteFilters>({
  nome: '',
})
